/**
 * @module DropdownControl
 */
import "./DropdownControl.css";
import Control from 'ol/control/Control';
import { t } from '../utils/i18n.js';

class DropdownControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'usa-dropdown-container ol-unselectable ol-control nhc-map-dropdown html2canvas-ignore';

    // Create the toggle button
    const button = document.createElement('button');
    button.className = 'usa-button usa-button--unstyled nhc-map-dropdown-button html2canvas-ignore';
    button.title = t('dropdown_button_tip');
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = `
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img" width="24" height="24">
        <use href="/assets/img/sprite.svg#more_vert"></use>
      </svg>
      <span class="usa-sr-only">Toggle map controls</span>
    `;

    // Create the dropdown content
    const dropdown = document.createElement('div');
    dropdown.className = 'usa-dropdown nhc-map-dropdown-content html2canvas-ignore';
    dropdown.hidden = true;

    dropdown.innerHTML = `
      <button id="close-button" class="usa-button usa-button--unstyled nhc-close-button">
        <span>${t('dropdown_close_menu')}</span>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/img/sprite.svg#close"></use>
        </svg>
      </button>
    `;

    // Add elements to container
    container.appendChild(button);
    container.appendChild(dropdown);

    super({
      element: container,
      target: options.target
    });

    // Store references to DOM elements
    this.container = container;
    this.button = button;
    this.dropdown = dropdown;
    this.closeButton = dropdown.querySelector('#close-button');

    // Bind event handlers
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(e);
    });
    
    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeDropdown(e);
    });

    // Add click outside listener to close dropdown
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.closeDropdown(e);
      }
    });
  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
    const labelSpan = this.closeButton.querySelector('span');
    if (labelSpan) {
      labelSpan.textContent = t("dropdown_close_menu");
    }
    const button = document.querySelector(`.nhc-map-dropdown-button`);
    if (button) {
      button.title = t('dropdown_button_tip');
    }
  }

  /**
   * Returns the HTML element that should be the target for child controls.
   * @returns {HTMLElement}
   */
  getContainerElement() {
    return this.dropdown;
  }

  /**
   * Adds an already instantiated control to the dropdown's content area.
   * @param {Control} controlInstance - The control instance to add.
   */
  addControl(controlInstance) {
    // The control's main element is appended to our content container
    this.dropdown.appendChild(controlInstance.element);
  }

  /**
   * Toggles the visibility of the dropdown menu.
   * @param {object} event 
   */
  toggleDropdown(event) {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !isExpanded);
    this.dropdown.hidden = isExpanded;
  }

  /**
   * Closes the dropdown menu.
   * @param {object} event 
   */
  closeDropdown(event) {
    this.button.setAttribute('aria-expanded', 'false');
    this.dropdown.hidden = true;
  }

}

export default DropdownControl;